export type UuidCrypto = {
    randomUUID?: () => string
    getRandomValues?: (array: Uint8Array) => void
}

function browserUuidCrypto(): UuidCrypto {
    const cryptoApi = globalThis.crypto

    return {
        randomUUID:
            typeof cryptoApi?.randomUUID === 'function'
                ? cryptoApi.randomUUID.bind(cryptoApi)
                : undefined,
        getRandomValues:
            typeof cryptoApi?.getRandomValues === 'function'
                ? (array) => {
                      const randomBytes = new Uint8Array(array.length)
                      cryptoApi.getRandomValues(randomBytes)
                      array.set(randomBytes)
                  }
                : undefined,
    }
}

/**
 * Creates a UUID v4 even when the browser does not expose `crypto.randomUUID`.
 * This can happen locally since `randomUUID` is only available in secure
 * contexts in some browsers.
 */
export function createUuid(cryptoApi: UuidCrypto = browserUuidCrypto()): string {
    if (typeof cryptoApi.randomUUID === 'function') {
        return cryptoApi.randomUUID()
    }

    const bytes = new Uint8Array(16)
    if (typeof cryptoApi.getRandomValues === 'function') {
        cryptoApi.getRandomValues(bytes)
    } else {
        for (let index = 0; index < bytes.length; index += 1) {
            bytes[index] = Math.floor(Math.random() * 256)
        }
    }

    bytes[6] = (bytes[6]! & 0x0f) | 0x40
    bytes[8] = (bytes[8]! & 0x3f) | 0x80

    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
